import { DocumentCategory } from 'modules/types/Document';
import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const getDocuments = async (params: {
  documentCategory?: DocumentCategory;
}) => {
  const requestParams = new URLSearchParams();

  if (params.documentCategory) {
    requestParams.append('documentType', params.documentCategory);
  }

  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/document`,
    { params: requestParams },
  );

  const {
    data: { content, totalPages },
  } = response;

  return { documents: content, totalPageCount: totalPages };
};

// FRON-599 documentCategory is ignored for now
export const uploadDocuments = async (params: {
  formData: FormData;
  documentCategory: DocumentCategory;
}) => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/document/upload`,
    params.formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response.data;
};

export const getDocumentTypeCodes = async () => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/uwt-code/document-type`,
  );

  const {
    data: { content },
  } = response;

  return {
    documentTypes: { data: content },
  };
};
